<template>
    <div class="card-view">
      <naka-info :key="cardId"></naka-info>
      <nakas-list></nakas-list>
    </div>
  </template>
  
  <script>
  import { useRoute } from 'vue-router';
  import { computed } from 'vue';
  import NakaInfo from '@/components/NakaInfo.vue'
  import NakasList from '@/components/NakasList.vue'
  
  export default {
    name: 'CardView',
    components: {
      NakaInfo,
      NakasList
    },
    setup() {
      const route = useRoute();
      const cardId = computed(() => String(route.params.id));
  
      return {
        cardId
      };
    }
  }
  </script>
